import { render, staticRenderFns } from "./EditProject.vue?vue&type=template&id=f5b3f4dc&scoped=true&"
import script from "./EditProject.vue?vue&type=script&lang=js&"
export * from "./EditProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b3f4dc",
  null
  
)

export default component.exports